import React, { useContext } from 'react';
import { graphql } from 'gatsby';

import styled, { css } from 'styled-components';
import { Section } from '../../Section';
import { Panel } from '../../Panel';
import { HeroSearch } from '../../search/HeroSearch';
import { Grid } from '../../Grid';
import { CTACard } from '../../CtaCard';
import { SearchCategory } from '../../../types/enums';
import { UiStateContext } from '../../../context/UiStateContext';
import { RequestAValuationBlade } from '../../properties/RequestAValuationBlade';
import { useExperiments } from '../../../context/ExperimentsContext';

export const StyledValuationBanner = styled(CTACard)`
  ${({ theme: { media } }) => css`
    text-align: left;
    text-wrap: pretty;

    > div {
      flex-grow: 0;
    }

    @media (min-width: ${media.lg}) {
      text-align: center;
    }
  `};
`;

const linkItems = [
  { text: 'Mortgages and Insurance', url: '/services/financial-services/', state: { fromSearchResults: true } },
  { text: 'Property Solicitors', url: '/services/property-solicitors/', state: { fromSearchResults: true } },
  {
    text: 'Survey and Professional Services',
    url: '/services/surveying-and-professional-services/',
    state: { fromSearchResults: true },
  },
  { text: 'See all our services', url: '/services', state: { fromSearchResults: true } },
];

export const PropertySearch = ({ data: { ctaCard, searchType } }) => {
  const category = searchType?.toLowerCase() === 'rent' ? SearchCategory.Rental : SearchCategory.Resale;
  const { setActiveBlade } = useContext(UiStateContext);
  const { experiments } = useExperiments();
  const isKFH25004Variation = experiments?.KFH25004 === 'variation';

  return (
    <>
      <Section contained background={isKFH25004Variation ? 'white' : 'gradient'} padding="large">
        <Grid desktopColumns="2">
          <Panel
            backgroundColor="white"
            shadow={!isKFH25004Variation}
            border={isKFH25004Variation}
            heading="Find a property"
            headingComponent="h2"
          >
            <HeroSearch defaultCategory={category} />
          </Panel>
          {ctaCard.button ? (
            <CTACard {...ctaCard} />
          ) : (
            <>
              <CTACard
                title="Need a valuation?"
                lead="Our local agents can provide an accurate valuation for your property."
                backgroundColour="brand"
                shadow
                customButton={{
                  label: 'Request a valuation',
                  onClick: () => setActiveBlade('propertyRequestAValuation'),
                  eventClickBladeId: 'propertyRequestAValuation',
                }}
              />
              <RequestAValuationBlade />
            </>
          )}
        </Grid>
      </Section>
      {isKFH25004Variation && (
        <Section contained background="white" padding="large">
          <StyledValuationBanner
            title="Specialist services at every stage of your property journey"
            backgroundColour="brand"
            tightSpacing
            linkItems={linkItems}
          />
        </Section>
      )}
    </>
  );
};

export const PropertySearchQuery = graphql`
  fragment PropertySearch on KFH_UmbracoPropertySearchComponentType {
    searchType
    ctaCard {
      ...CtaCard
    }
  }
`;
